(function () {
  function getVariants(container) {
    var jsonEl = container.querySelector('[data-variant-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.warn('[swatches-product-image] Invalid variant JSON', e);
      return null;
    }
  }

  function getSelectedOptions(container) {
    var selects = container.querySelectorAll('select.dynamic-variant-input');
    if (!selects.length) return null;
    return Array.prototype.map.call(selects, function (select) {
      return select.value;
    });
  }

  function findVariant(variants, options) {
    if (!variants || !options || !options.length) return null;
    return variants.find(function (variant) {
      return options.every(function (opt, index) {
        return variant.options[index] === opt;
      });
    });
  }

  function getFeaturedImageUrl(variant) {
    if (!variant || !variant.featured_image) return null;
    if (typeof variant.featured_image === 'string') return variant.featured_image;
    return variant.featured_image.src || null;
  }

  function getMainImages(container) {
    return container.querySelectorAll('.image img:not(.hover)');
  }

  function showImageByVariantId(container, variantId) {
    var images = getMainImages(container);
    if (!images.length) return false;

    var matched = false;
    images.forEach(function (img) {
      if (!img.dataset.variantId) return;
      var isMatch = String(img.dataset.variantId) === String(variantId);
      img.classList.toggle('hidden', !isMatch);
      if (isMatch) matched = true;
    });

    return matched;
  }

  function showImageByOptionHandle(container, optionHandle) {
    if (!optionHandle) return false;
    var images = getMainImages(container);
    var matched = false;

    images.forEach(function (img) {
      if (!img.dataset.optionHandle) return;
      var isMatch = img.dataset.optionHandle === optionHandle;
      img.classList.toggle('hidden', !isMatch);
      if (isMatch) matched = true;
    });

    return matched;
  }

  function showImageByIndex(container, index) {
    var images = getMainImages(container);
    if (!images.length || !index) return false;

    var targetIndex = parseInt(index, 10) - 1;
    if (isNaN(targetIndex) || targetIndex < 0 || targetIndex >= images.length) return false;

    images.forEach(function (img, i) {
      img.classList.toggle('hidden', i !== targetIndex);
    });

    return true;
  }

  function updateImageFromVariant(container, variant) {
    if (!variant) return;

    if (showImageByVariantId(container, variant.id)) return;

    var imageUrl = getFeaturedImageUrl(variant);
    var images = getMainImages(container);
    if (!images.length) return;

    if (imageUrl) {
      images[0].src = imageUrl;
      images.forEach(function (img, i) {
        img.classList.toggle('hidden', i !== 0);
      });
    }
  }

  function updateProductCardImage(container) {
    if (!container) return;

    var variants = getVariants(container);
    if (variants) {
      var options = getSelectedOptions(container);
      var variant = findVariant(variants, options);
      if (variant) {
        updateImageFromVariant(container, variant);
        return;
      }
    }

    var activeSwatch = container.querySelector('.product__color-swatch.selected');
    if (activeSwatch) {
      if (showImageByOptionHandle(container, activeSwatch.dataset.optionHandle)) return;

      var radioId = activeSwatch.getAttribute('for');
      var radio = radioId ? document.getElementById(radioId) : null;
      if (!radio && activeSwatch.previousElementSibling) {
        radio = activeSwatch.previousElementSibling;
      }
      if (radio && radio.dataset.index) {
        showImageByIndex(container, radio.dataset.index);
      }
    }
  }

  function getContainerFromTarget(target) {
    return target.closest('.product-container');
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target) return;

    if (
      target.matches('select.dynamic-variant-input') ||
      (target.matches('.product__color-swatch-radio') && target.checked)
    ) {
      var container = getContainerFromTarget(target);
      if (container) updateProductCardImage(container);
    }
  });

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.product-container .product__color-swatch');
    if (!swatch) return;

    var container = getContainerFromTarget(swatch);
    if (!container) return;

    // OptionButtons runs on the same tick; defer so the hidden select is updated first.
    window.requestAnimationFrame(function () {
      if (swatch.dataset.variantId && showImageByVariantId(container, swatch.dataset.variantId)) {
        return;
      }

      if (showImageByOptionHandle(container, swatch.dataset.optionHandle)) return;

      var radioId = swatch.getAttribute('for');
      var radio = radioId ? document.getElementById(radioId) : swatch.previousElementSibling;
      if (radio && radio.dataset.index) {
        showImageByIndex(container, radio.dataset.index);
        return;
      }

      updateProductCardImage(container);
    });
  });
})();
